import { render, staticRenderFns } from "./Dropshipping.vue?vue&type=template&id=0c225b4e&scoped=true"
import script from "./Dropshipping.vue?vue&type=script&lang=js"
export * from "./Dropshipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c225b4e",
  null
  
)

export default component.exports